var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRightBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 20,
    viewBox: "0 0 10 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.98223 10L0.366117 2.43872C-0.122039 1.88083 -0.122039 0.976311 0.366117 0.418419C0.854272 -0.139473 1.64573 -0.139473 2.13388 0.418419L9.63388 8.98985C10.122 9.54774 10.122 10.4523 9.63388 11.0102L2.13388 19.5816C1.64573 20.1395 0.854272 20.1395 0.366117 19.5816C-0.122039 19.0237 -0.122039 18.1192 0.366117 17.5613L6.98223 10Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightBlack);
export default __webpack_public_path__ + "static/media/chevron-right-black.f42870e33929785407dc182d1d7bbab2.svg";
export { ForwardRef as ReactComponent };